module.exports = __webpack_public_path__ + "static/media/14.532a67bf.jpg";